import { Dropdown } from "primereact/dropdown";
import { ReactComponent as Frame_bot } from "../../assets/Frame_bot.svg";
import { ReactComponent as WEB } from "../../assets/WEB.svg";

import React from "react";

const ConfigureAI = ({ registrationForm, setRegistrationForm }) => {
  const handleDropdownChange = (e, field) => {
    setRegistrationForm((prev) => ({
      ...prev,
      [field]: e.value,
    }));
  };

  const sectorOptions = [
    {
      label: "Ecommerce",
      value: "ECOMMERCE",
    },
  ];

  const featureOptions = [
    {
      label: "Conversational AI",
      value: "CONVERSATIONAL",
    },
    { label: "FAQs & Conversation AI", value: "FAQ_CONVERSATIONAL" },
    { label: "Actions & Conversation AI", value: "ACTIONS_CONVERSATIONAL" },
    {
      label: "FAQ & Actions & Conversational AI",
      value: "ACTIONS_FAQ_CONVERSATIONAL",
    },
  ];

  return (
    <div className="border border-red-500 rounded-md">
      <div className="pt-3">
        <span className="text-lg font-medium">
          <WEB className="mx-1 pt-1" />
          Customize the bot based on your company’s requirements
        </span>
      </div>
      <div className="flex justify-content-between align-items-start p-2">
        <div className="mb-3 mt-3 w-full pr-8">
          <div className="mb-4 mt-3">
            <label className="block mb-2 text-gray-900">Company Sector</label>
            <Dropdown
              value={registrationForm?.companySector}
              options={sectorOptions}
              onChange={(e) => handleDropdownChange(e, "companySector")}
              className="w-full"
              placeholder="Select a sector"
            />
          </div>

          {/* AI Features Dropdown */}
          <div className="mb-4 mt-3">
            <label className="block mb-2 text-gray-900">AI Features</label>
            <Dropdown
              value={registrationForm?.aiFeature}
              options={featureOptions}
              onChange={(e) => handleDropdownChange(e, "aiFeature")}
              className="w-full"
              placeholder="Select features"
            />
          </div>

          {/* Additional Features Dropdown */}
          <div className="mb-4 mt-3">
            <label className="block mb-2 text-gray-900">
              Additional Features
            </label>
            <Dropdown
              className="w-full"
              placeholder="Select features"
              disabled
            />
          </div>
        </div>

        <div>
          <div className="p-4 flex justify-center items-center">
            <Frame_bot />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfigureAI;
